import { type MutationHookOptions, useMutation } from "@apollo/client";
import { ConnectBunnyByAccountMutation } from "../graphql/mutations";
import type {
  ConnectBunnyByAccountMutationType,
  ConnectBunnyByAccountMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useConnectBunnyByAccountMutation = (
  options?: MutationHookOptions<
    ConnectBunnyByAccountMutationType,
    ConnectBunnyByAccountMutationVariablesType
  >
) => {
  return useMutation<
    ConnectBunnyByAccountMutationType,
    ConnectBunnyByAccountMutationVariablesType
  >(ConnectBunnyByAccountMutation, options);
};
